import { ReactLazyLoading } from "@/containers/ReactLoading";
import { useAppSelector } from "@/hooks";
import { sessionSelector } from "@/store/sessionReducer";

type PropsType = { show: boolean; onHide: () => void };

const COMPONENTS: TTDict<string, TTDict<string, React.ComponentType<PropsType>>> = {
  "sevenit-gmbh": {
    sevdesk: ReactLazyLoading(() => import("@/customers/sevenit/Hotseat/ForwardModal")),
  },
};

// eslint-disable-next-line react-refresh/only-export-components
export const hasModal = (session: SessionInterface): boolean =>
  !!COMPONENTS[session.currentCustomer.identifier]?.[session.currentProject.identifier] ||
  !!COMPONENTS[session.currentCustomer.identifier]?.default;

export default function SpecificComponent(props: PropsType) {
  const { currentCustomer, currentProject } = useAppSelector(sessionSelector);

  const Component =
    COMPONENTS[currentCustomer.identifier]?.[currentProject.identifier] ||
    COMPONENTS[currentCustomer.identifier]?.default;

  if (!Component) {
    return null;
  }

  return <Component {...props} />;
}
